import {
  KYDBlockData,
  KYDCampaignEvent,
  KYDEmailTemplate,
  KYDEventBlockData,
  KYDEventBlockDataV2,
  KYDEventListItemData,
} from "interfaces/KYDCampaign";

export const DEFAULT_EVENT_DATA: KYDCampaignEvent = {
  id: "",
  name: "Event Name",
  image: "",
  start_at: "",
  end_at: "",
  link: "",
  is_external: false,
  venue: undefined,
  timezone: undefined,
};

export const DEFAULT_EVENT_LIST_ITEM_DATA: KYDEventListItemData = {
  id: undefined,
  event: DEFAULT_EVENT_DATA,
  subcopy: "",
};

export const DEFAULT_EVENT_BLOCK_DATA: KYDEventBlockData = {
  id: undefined,
  event: DEFAULT_EVENT_DATA,
  custom_image: "",
  button_text: "Buy Tickets",
  door_time: "",
  show_time: "",
  body: "",
};

export const DEFAULT_DIVIDER_BLOCK_DATA = {
  type: "divider" as const,
};

export const DEFAULT_BUTTON_BLOCK_DATA = {
  type: "button" as const,
  title: "Learn More",
  link: "",
  width: 100,
};

const DEFAULT_EVENT_BLOCK_DATA_V2: KYDEventBlockDataV2 = {
  id: undefined,
  event: DEFAULT_EVENT_DATA,
  custom_image: "",
  button_text: "Buy Tickets",
  door_time: "",
  show_time: "",
  body: {
    type: "doc",
    content: [
      {
        type: "paragraph",
        content: [{ type: "text", text: "Event copy" }],
      },
    ],
  },
};

export const TEMPLATE_BLOCKS: Partial<KYDEmailTemplate>[] = [
  {
    type: "WEEKLY_NEWSLETTER",
    version: 1,
    name: "Weekly Newsletter",
    description: "Weekly - Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "eventList",
        events: [DEFAULT_EVENT_LIST_ITEM_DATA],
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
    ] as KYDBlockData[],
  },
  {
    type: "WEEKLY_NEWSLETTER",
    version: 3,
    name: "Weekly Newsletter",
    description: "Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        preheadline: "preheadline",
        subheadline: "subheadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "eventList",
        events: [DEFAULT_EVENT_LIST_ITEM_DATA],
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
    ] as KYDBlockData[],
  },
  {
    type: "WEEKLY_NEWSLETTER",
    version: 4,
    name: "Weekly Newsletter",
    description: "Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        preheadline: "preheadline",
        subheadline: "subheadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "eventList",
        events: [DEFAULT_EVENT_LIST_ITEM_DATA],
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
    ] as KYDBlockData[],
  },
  {
    type: "WEEKLY_PRESS_EMAIL",
    version: 1,
    name: "Weekly Press Email",
    description: "Weekly - Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "eventList",
        events: [DEFAULT_EVENT_LIST_ITEM_DATA],
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
    ] as KYDBlockData[],
  },
  {
    type: "WEEKLY_PRESS_EMAIL",
    version: 3,
    name: "Weekly Press Email",
    description: "Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        preheadline: "preheadline",
        subheadline: "subheadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "eventList",
        events: [DEFAULT_EVENT_LIST_ITEM_DATA],
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
    ] as KYDBlockData[],
  },
  {
    type: "WEEKLY_PRESS_EMAIL",
    version: 4,
    name: "Weekly Press Email",
    description: "Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        preheadline: "preheadline",
        subheadline: "subheadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "eventList",
        events: [DEFAULT_EVENT_LIST_ITEM_DATA],
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA_V2,
      },
    ] as KYDBlockData[],
  },
  {
    type: "LATE_NIGHTS",
    version: 2,
    name: "Late Nights",
    description: "Late Nights - Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: "LATE_NIGHTS",
    version: 3,
    name: "Late Nights",
    description: "Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        preheadline: "preheadline",
        subheadline: "subheadline",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: "LATE_NIGHTS",
    version: 4,
    name: "Late Nights",
    description: "Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        preheadline: "preheadline",
        subheadline: "subheadline",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA_V2, DEFAULT_EVENT_BLOCK_DATA_V2],
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA_V2, DEFAULT_EVENT_BLOCK_DATA_V2],
      },
    ] as KYDBlockData[],
  },
  {
    type: "LATE_NIGHTS",
    version: 1,
    name: "Late Nights",
    description: "Late Nights - Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [],
      },
      {
        type: "event2col",
        events: [],
      },
    ] as KYDBlockData[],
  },
  {
    type: "EVENT_ANNOUNCEMENT",
    version: 3,
    name: "Event Announcement",
    description: "Event Announcement + video/photo",
    blocks: [
      {
        type: "textHeadline",
        preheadline: "preheadline",
        subheadline: "subheadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
      {
        type: "textBody",
        body: "Event copy",
      },
      {
        type: "image",
        src: "",
        width: 100,
      },
    ] as KYDBlockData[],
  },
  {
    type: "EVENT_ANNOUNCEMENT",
    version: 4,
    name: "Event Announcement",
    description: "Event Announcement + video/photo",
    blocks: [
      {
        type: "textHeadline",
        preheadline: "preheadline",
        subheadline: "subheadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA_V2,
      },
      {
        type: "textBody",
        body: "",
      },
      {
        type: "image",
        src: "",
        width: 100,
      },
    ] as KYDBlockData[],
  },
  {
    type: "EVENT_ANNOUNCEMENT",
    version: 2,
    name: "Event Announcement",
    description: "Event Announcement - Single event listing",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
      {
        type: "image",
        src: "",
        width: 100,
      },
    ] as KYDBlockData[],
  },
  {
    type: "EVENT_ANNOUNCEMENT",
    version: 1,
    name: "Event Announcement",
    description: "Event Announcement - Single event listing",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [],
      },
      {
        type: "image",
        src: "",
        width: 100,
      },
    ] as KYDBlockData[],
  },
  {
    type: "PRESALE_EVENT_MULTIPLE",
    version: 1,
    name: "Presale Event Multiple",
    description: "Presale Event - Single event listing",
    blocks: [
      {
        type: "textHeadline",
        headline: "Presale",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [],
      },
      {
        type: "video",
        src: "",
      },
    ] as KYDBlockData[],
  },
  {
    type: "PRESALE_EVENT_MULTIPLE",
    version: 2,
    name: "Presale Event Multiple",
    description: "Presale Event - Single event listing",
    blocks: [
      {
        type: "textHeadline",
        headline: "Presale",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
      {
        type: "video",
        src: "",
      },
    ] as KYDBlockData[],
  },
  {
    type: "PRESALE_EVENT_MULTIPLE",
    version: 3,
    name: "Presale Event",
    description: "Event announcement + video/photo",
    blocks: [
      {
        type: "textHeadline",
        headline: "Presale",
        preheadline: "preheadline",
        subheadline: "subheadline",
        link_headline_to_event: false,
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
      {
        type: "video",
        src: "",
      },
    ] as KYDBlockData[],
  },
  {
    type: "PRESALE_EVENT_MULTIPLE",
    version: 4,
    name: "Presale Event",
    description: "Event announcement + video/photo",
    blocks: [
      {
        type: "textHeadline",
        headline: "Presale",
        preheadline: "preheadline",
        subheadline: "subheadline",
        link_headline_to_event: false,
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA_V2,
      },
      {
        type: "video",
        src: "",
      },
    ] as KYDBlockData[],
  },
  {
    type: "PRESS_RELEASE_MULTIPLE",
    version: 3,
    name: "Press Release Multiple",
    description: "2 column event announcement",
    blocks: [
      {
        type: "textHeadline",
        headline: "Press Release",
        preheadline: "preheadline",
        subheadline: "subheadline",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: "PRESS_RELEASE_MULTIPLE",
    version: 4,
    name: "Press Release Multiple",
    description: "2 column event announcement",
    blocks: [
      {
        type: "textHeadline",
        headline: "Press Release",
        preheadline: "preheadline",
        subheadline: "subheadline",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA_V2, DEFAULT_EVENT_BLOCK_DATA_V2],
      },
    ] as KYDBlockData[],
  },
  {
    type: "PRESS_RELEASE_MULTIPLE",
    version: 2,
    name: "Press Release Multiple",
    description: "Press Release Multiple - Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Press Release",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: "PRESS_RELEASE_MULTIPLE",
    version: 1,
    name: "Press Release Multiple",
    description: "Press Release Multiple - Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Press Release",
        link_headline_to_event: false,
      },
      {
        type: "event2col",
        events: [],
      },
    ] as KYDBlockData[],
  },
  {
    type: "GENRE_GROUPED_EVENTS",
    version: 3,
    name: "Genre Grouped Events",
    description: "1 & 2 column mixed event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        preheadline: "preheadline",
        subheadline: "subheadline",
        link_headline_to_event: false,
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: "GENRE_GROUPED_EVENTS",
    version: 4,
    name: "Genre Grouped Events",
    description: "1 & 2 column mixed event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        preheadline: "preheadline",
        subheadline: "subheadline",
        link_headline_to_event: false,
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA_V2,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA_V2, DEFAULT_EVENT_BLOCK_DATA_V2],
      },
    ] as KYDBlockData[],
  },
  {
    type: "GENRE_GROUPED_EVENTS",
    version: 2,
    name: "Genre Grouped Events",
    description: "Genre Grouped Events - Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "Weekly",
        link_headline_to_event: false,
      },
      {
        type: "event1col",
        event: DEFAULT_EVENT_BLOCK_DATA,
      },
      {
        type: "event2col",
        events: [DEFAULT_EVENT_BLOCK_DATA, DEFAULT_EVENT_BLOCK_DATA],
      },
    ] as KYDBlockData[],
  },
  {
    type: "GENRE_GROUPED_EVENTS",
    version: 1,
    name: "Genre Grouped Events",
    description: "Genre Grouped Events - Multiple event listings",
    blocks: [
      {
        type: "textHeadline",
        headline: "LPR Weekly",
        link_headline_to_event: false,
      },
      {
        type: "event1col",
        event: {},
      },
      {
        type: "event2col",
        events: [],
      },
    ] as KYDBlockData[],
  },
  {
    type: "BLANK_TEMPLATE",
    version: 1,
    name: "Blank Template",
    description: "Use blocks to build your own",
    blocks: [],
  },
  {
    type: "BLANK_TEMPLATE",
    version: 2,
    name: "Blank Template",
    description: "Use blocks to build your own",
    blocks: [],
  },
  {
    type: "BLANK_TEMPLATE",
    version: 3,
    name: "Blank Template",
    description: "Use blocks to build your own",
    blocks: [],
  },
  {
    type: "BLANK_TEMPLATE",
    version: 4,
    name: "Blank Template",
    description: "Use blocks to build your own",
    blocks: [],
  },
];
